import { render } from "./HeaderNaviSwitchButtonForSpLayout.vue?vue&type=template&id=699feb91&scoped=true&ts=true"
import script from "./HeaderNaviSwitchButtonForSpLayout.vue?vue&type=script&lang=ts"
export * from "./HeaderNaviSwitchButtonForSpLayout.vue?vue&type=script&lang=ts"

import "./HeaderNaviSwitchButtonForSpLayout.vue?vue&type=style&index=0&id=699feb91&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699feb91"]])

export default __exports__